<template>
  <ExtracadabraModal v-model:opened="internalOpen" size="sm">
    <template #body>
      <ExtraSelectedSuccess />
    </template>
    <template #footer>
      <QBtn v-close-popup class="full-width btn-navigation" color="secondary" no-caps :label="$t('ETAB.PAGES.EXTRA.EXTRA_SELECTED_MODAL.@ACTION')" />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";
  import ExtraSelectedSuccess from "@etab/components/success/ExtraSelected.component.vue";

  export default {
    components: {
      ExtraSelectedSuccess,
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:opened"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
  };
</script>
